module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-layout-gallery"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n      Dynamic Gallery.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle",
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n      Creating a customized dynamic grid system using Vue + Bulma's flex tile layout. "), _c('br'), _vm._v("\n      Inspiration from simplex-d site by utilizing pagejoint.com's layout engine & reverse engineered "), _c('i', {
    staticClass: "material-icons color-orange"
  }, [_vm._v("favorite")]), _vm._v(" the CSS layout."), _c('br'), _vm._v("\n      Click button below to see the difference!"), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "button is-white",
    on: {
      "click": function($event) {
        _vm.refresh()
      }
    }
  }, [_vm._v("Refresh")])])]), _vm._v(" "), _c('div', {
    staticClass: "container gallery-container",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_vm._l((_vm.segments), function(segment, segmentIndex) {
    return _c('div', {
      staticClass: "tile is-ancestor"
    }, [(segment.selection === 0) ? _c('div', {
      staticClass: "tile is-parent tx_type_0"
    }, _vm._l((segment.images), function(image) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    })) : (segment.selection === 1 || segment.selection === 2) ? _c('div', {
      staticClass: "tile is-parent tx_type_1-2"
    }, _vm._l((segment.images), function(image, index) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h",
        class: {
          'is-4 tx_full_h1': (segment.selection === 1 && index == 0) || (segment.selection === 2 && index == 1),
          'is-8 tx_full_h3': (segment.selection === 1 && index == 1) || (segment.selection === 2 && index == 0)
        }
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    })) : (segment.selection === 3 || segment.selection === 5) ? _c('div', {
      staticClass: "tile is-parent tx_type_3or5"
    }, [_vm._l(([segment.images[0]]), function(image) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h",
        class: {
          'is-4 tx_full_h2': segment.selection === 3, 'is-8 tx_full_h1': segment.selection === 5
        }
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_1280 + ')'
        })
      })])])
    }), _vm._v(" "), _c('div', {
      staticClass: "tile is-vertical",
      class: {
        'is-4': segment.selection === 5, 'is-8': segment.selection === 3
      }
    }, [_vm._l(([segment.images[1]]), function(image) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h3"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    }), _vm._v(" "), _vm._l(([segment.images[2]]), function(image) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h3"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    })], 2)], 2) : (segment.selection === 4 || segment.selection === 6) ? _c('div', {
      staticClass: "tile is-parent tx_type_4or6"
    }, [_c('div', {
      staticClass: "tile is-vertical",
      class: {
        'is-8': segment.selection === 4, 'is-4': segment.selection === 6
      }
    }, [_vm._l(([segment.images[0]]), function(image) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h3"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    }), _vm._v(" "), _vm._l(([segment.images[1]]), function(image) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h3"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    })], 2), _vm._v(" "), _vm._l(([segment.images[2]]), function(image) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h",
        class: {
          'is-8 tx_full_h1': segment.selection === 6, 'is-4 tx_full_h2': segment.selection === 4
        }
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_1280 + ')'
        })
      })])])
    })], 2) : (segment.selection >= 7 && segment.selection <= 10) ? _c('div', {
      staticClass: "tile is-parent tx_type_7to10"
    }, [_vm._l(([segment.images[3]]), function(image) {
      return (segment.selection === 9 || segment.selection === 10) ? _c('div', {
        staticClass: "tile is-child is-4 tx_full_h tx_full_h2"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_1280 + ')'
        })
      })])]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "tile is-vertical is-8"
    }, [_vm._l(([segment.images[0]]), function(image) {
      return (segment.selection === 7 || segment.selection === 9) ? _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h3"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "tile is-parent"
    }, [_vm._l(([segment.images[1]]), function(image) {
      return _c('div', {
        staticClass: "tile is-child is-6 tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    }), _vm._v(" "), _vm._l(([segment.images[2]]), function(image) {
      return _c('div', {
        staticClass: "tile is-child is-6 tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    })], 2), _vm._v(" "), _vm._l(([segment.images[0]]), function(image) {
      return (segment.selection === 8 || segment.selection === 10) ? _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h3"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])]) : _vm._e()
    })], 2), _vm._v(" "), _vm._l(([segment.images[3]]), function(image) {
      return (segment.selection === 7 || segment.selection === 8) ? _c('div', {
        staticClass: "tile is-child is-4 tx_full_h tx_full_h2"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_1280 + ')'
        })
      })])]) : _vm._e()
    })], 2) : (segment.selection >= 11 && segment.selection <= 13) ? _c('div', {
      staticClass: "tile is-parent tx_type_11to13"
    }, [_vm._l(([segment.images[4]]), function(image) {
      return (segment.selection === 12) ? _c('div', {
        staticClass: "tile is-child is-4 tx_full_h tx_full_h2"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_1280 + ')'
        })
      })])]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "tile is-vertical is-4 segment-11"
    }, [_vm._l(([segment.images[0]]), function(image) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    }), _vm._v(" "), _vm._l(([segment.images[1]]), function(image) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    })], 2), _vm._v(" "), _vm._l(([segment.images[4]]), function(image) {
      return (segment.selection === 13) ? _c('div', {
        staticClass: "tile is-child is-4 tx_full_h tx_full_h2"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_1280 + ')'
        })
      })])]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "tile is-vertical is-4"
    }, [_vm._l(([segment.images[2]]), function(image) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    }), _vm._v(" "), _vm._l(([segment.images[3]]), function(image) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    })], 2), _vm._v(" "), _vm._l(([segment.images[4]]), function(image) {
      return (segment.selection === 11) ? _c('div', {
        staticClass: "tile is-child is-4 tx_full_h tx_full_h2"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_1280 + ')'
        })
      })])]) : _vm._e()
    })], 2) : _c('div', {
      staticClass: "tile is-parent"
    }, _vm._l((segment.images), function(image) {
      return _c('div', {
        staticClass: "tile is-child is-4 tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    }))])
  }), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]) : _vm._e()], 2), _vm._v(" "), _c('section-comment')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cfad5194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages_showcase/LayoutGallery.vue
// module id = 838
// module chunks = 1